import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { FluidModule } from 'primeng/fluid';
import { GenericDetailsFormComponent } from './generic-details-form/generic-details-form.component';
import { RegistrationMessageComponent } from './registration-message/registration-message.component';
import { RegistrationService } from './registration.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-registration',
  imports: [
    ButtonModule,
    FluidModule,
    GenericDetailsFormComponent,
    RegistrationMessageComponent,
  ],
  templateUrl: './registration.component.html',
})
export class RegistrationComponent implements OnInit, OnDestroy {
  currentStep: number = 1;

  private registrationStepSub = Subscription.EMPTY;

  private readonly _registrationService = inject(RegistrationService);

  constructor() {
    this.currentStep = 1;
    this._registrationService.setRegistrationStep(1);
  }

  ngOnInit(): void {
    this.registrationStepSub =
      this._registrationService.registrationStep$.subscribe(
        (currentStep) => (this.currentStep = currentStep)
      );
  }

  ngOnDestroy(): void {
    this.registrationStepSub.unsubscribe();
  }
}
